import { AnalyticsBrowser } from "@segment/analytics-next";

import { IAnalyticsAdapter } from "../IAnalyticsAdapter";
import {
  AnalyticsOptions,
  AnalyticsProperties,
  AnalyticsTraits,
} from "../types";

export class SegmentAdapter implements IAnalyticsAdapter {
  public segment?: AnalyticsBrowser;
  private platformId?: string;

  constructor(writeKey?: string) {
    if (writeKey) {
      this.segment = new AnalyticsBrowser();

      this.segment.load({ writeKey });

      console.log("Segment initialized");
    } else {
      console.warn(
        `REACT_APP_SEGMENT_WRITE_KEY variable not provided, segment is not initialized`
      );
    }
  }

  track(
    event: string,
    properties?: AnalyticsProperties,
    options?: AnalyticsOptions
  ): void {
    const mergedOptions = {
      ...(options || {}),
      context: {
        ...((options?.context as Record<string, unknown>) || {}),
        groupId: this.platformId,
      },
    };

    this.segment?.track(event, properties, mergedOptions);
  }

  page(name: string, properties?: AnalyticsProperties): void {
    this.segment?.page(name, properties);
  }

  identify(userId: string, traits?: AnalyticsTraits): void {
    this.platformId = traits?.platformId;
    this.segment?.identify(userId, traits);
  }

  reset(): void {
    this.segment?.reset();
  }
}
